<template>
  <div class="store-setting-body">
		<ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li
				v-for="item in urlMaps"
				:key="item.url"
				@click="routerSwitch(item.url)"
				:class="{ active : active === item.url }"
			>{{item.name}}</li>
		</ul>
		<router-view></router-view>
  </div>
</template>

<script>
export default {
	name: 'goodsAttributes',
	data () {
		return {
			// urlMaps: [{
			// 	name: '商品信息',
			// 	url: 'goodsInfo'
			// }, {
			// 	name: '属性信息',
			// 	url: 'attributesInfo'
			// }, {
			// 	name: '运费管理',
			// 	url: 'goodsFreight'
			// }, {
			// 	name: '关联店铺',
			// 	url: 'relatedStore'
			// }],
			urlMaps: [{
				name: '商品信息',
				url: 'goodsInfo'
			}, {
				name: '属性信息',
				url: 'attributesInfo'
			}, {
				name: '关联店铺',
				url: 'relatedStore'
			}],
			active: 'goodsInfo'
		}
	},
	created () {
		let hashArr = location.hash.split('/')
		this.active = hashArr[hashArr.length - 1]
	},
	methods: {
		goBack () {
			this.$router.push('/main/goodsManagement')
		},
		routerSwitch (url) {
			// this.$router.push(url)
			// this.active = url
			let goodsid = sessionStorage.getItem('goodsid')
			if (goodsid) {
				this.$router.push(url)
				this.active = url
			} else {
				if (url !== 'goodsInfo') {
					this.$message.warning('请保存商品信息！')
				}
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.store-setting-body {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:66px;
		line-height: 66px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 66px
			padding-right 20px
			i {
				border-radius: 50%;
				background: #9da6af;
				padding: 3px;
				cursor: pointer;
			}
			.el-icon-back:before {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			cursor pointer
			height: 100%
			box-sizing:border-box
			float left
			&.active {
				border-bottom: 3px solid var(--fx-primary-color);
				font-weight: bold
			}
		}
	}
}
</style>
